import axios from 'axios/index'

const namespaced = true

const state = {
  detailingYears: [],
  detailingMonths: {},
  selectYearValue: null,
  selectMonthValue: null,
  billingData: null,
  isBusy: null
}
const getters = {
  detailingMonthSelect: state => {
    for (const key in state.detailingMonths) {
      console.log(key)
      if (state.selectYearValue === key) {
        console.log(state.detailingMonths[key])
        return state.detailingMonths[key]
      } else {
        return state.detailingMonths[key]
      }
    }
  }
}
const actions = {
  getDropdown ({ commit }) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/piportals/all/billing-detailing/dropdowns/'
    })
      .then(response => {
        commit('parseDropdownData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getDetailingReport ({ commit, state }) {
    commit('busyState', true)
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/piportals/all/billing-detailing?p_year=' + state.selectYearValue + '&p_month=' + state.selectMonthValue
    })
      .then(response => {
        commit('getBillingData', response.data.data)
        commit('busyState', false)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
const mutations = {
  parseDropdownData (state, data) {
    if (data.years.length !== 0) {
      state.detailingYears = data.years
      state.detailingMonths = data.months
      state.selectYearValue = data.years[data.years.length - 1].text
    }
  },
  updateBillingYear (state, data) {
    state.selectYearValue = data
  },
  updateBillingMonth (state, data) {
    state.selectMonthValue = data
  },
  getBillingData (state, data) {
    state.billingData = data
    state.isBusy = false
  },
  busyState (state, data) {
    state.isBusy = data
  }
}
export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
